<template>
    <b-form-group v-bind="$attrs" :invalid-feedback="invalidFeedback" :label-for="formControlId">
        <template v-slot:label>
            <template v-if="label">
                {{ label }}
                <csp-form-tooltip :tooltip="tooltip"/>
            </template>
        </template>
        <b-form-input :id="formControlId" :autocomplete="autocomplete"
            :class="[hideArrows ? 'hide-arrows' : '', potentiallyRequired ? 'border-yellow' : '']"
            :disabled="isReadOnlyProperty" :max="max" :maxlength="maxlength" :min="min"
            :name="formControlId" :placeholder="placeholder" :required="isRequiredProperty"
            :state="validationState" :step="step" :type="type" :value="data[property]"
            @blur="$emit('blur')"
            @change="$emit('change')"
            @input="handleInput"
            @keydown.enter="$emit('formGroupInputEnter')"/>
    </b-form-group>
</template>

<script>
    import '@scss/components/input.scss';
    import FormGroupMixin from './FormGroupMixin';

    export default {
        mixins: [FormGroupMixin],
        props: {
            type: {
                type: String,
                default: 'text',
            },
            maxlength: {
                type: Number,
                default: null,
            },
            max: {
                type: Number,
                default: null,
            },
            min: {
                type: Number,
                default: null,
            },
            nullIfEmpty: {
                type: Boolean,
                default: false,
            },
            step: {
                type: String,
                default: '1',
            },
            hideArrows: {
                type: Boolean,
                default: false,
            },
            autocomplete: { // also controls autofill
                type: String,
                default: 'off',
            },
            placeholder: {
                type: String,
                default: null,
            },
        },
        emits: ['blur', 'change', 'input', 'formGroupInputEnter'],
        methods: {
            handleInput(input) {
                if (this.nullIfEmpty && !input) {
                    input = null;
                }
                this.data[this.property] = input;
                this.$emit('input', input);
            },
        },
    }
</script>
